module.exports = __webpack_public_path__ + "img/Perks-Dropsmart-Joy-Bowles.a4132b7a.png";